module.exports = __webpack_public_path__ + "img/benchmark.e1df806d.png";